<!--评价类型-->
<template>
  <div style="min-height: 350px">
    <div class="header">
      <a-button @click="modelForm.visible = true" icon="plus" type="primary">添加评价类型</a-button>
    </div>
    <div style="overflow: auto">
      <a-table
        style="min-width: 800px"
        :columns="columns"
        rowKey="id"
        :scroll="{ y: 350 }"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <span slot="status" slot-scope="text">
          <a-switch @change="tableStatusChange(text)" v-model="text.enabled" checked-children="启用" un-checked-children="禁用" />
        </span>
        <div slot="action" slot-scope="text">
          <a @click="edit(text)" style="margin-right: 10px" href="javaScript:;">
            <a-icon type="edit" />
            编辑</a
          >
          <a-popconfirm title="确认删除此评价类型？" @confirm="del(text)">
            <a style="color: red" href="javaScript:;">
              <a-icon type="delete" />
              删除</a
            >
          </a-popconfirm>
        </div>
      </a-table>
    </div>

    <!--添加/编辑能力体系-->
    <a-modal
      v-model="modelForm.visible"
      :centered="true"
      :destroyOnClose="true"
      :title="modelForm.title"
      :confirm-loading="modelForm.confirmLoading"
      @cancel="modelFormCancel"
      @ok="modelFormOk"
      width="800px"
    >
      <a-form-model ref="myModelForm" style="max-height: 400px; overflow-y: auto" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }" :model="modelForm.data" :rules="modelForm.rules">
        <a-form-model-item label="评价类型" prop="referenceType">
          <a-input v-model="modelForm.data.referenceType" placeholder="请输入评价类型" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="modelForm.data.enabled">
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  {
    title: '评价类型',
    dataIndex: 'referenceType',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'AbilitySystemType',
  props: {
    abilitySystemTypeId: '',
  },
  data() {
    return {
      columns,
      //表格相关
      tableRelevant: tableRelevant.call(this),
      modelForm: {
        visible: false,
        confirmLoading: false,
        title: '添加评价类型',
        data: {
          id: undefined,
          referenceType: '',
          enabled: true,
        },
        rules: {
          referenceType: [
            { required: true, message: '请输入评价类型', trigger: 'blur' },
            { min: 2, max: 30, message: '评价类型长度为 2 到 30个字符', trigger: 'blur' },
          ],
        },
      },
    }
  },
  mounted() {
    this.getPageList()
  },
  methods: {
    //获取评价类型列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tableRelevant.tablePagination.current = pageIndex
      }
      const params = {
        AbilityEvaluationSysId: this.abilitySystemTypeId,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.getAbilitylevelReferencetype(params)
        .then((res) => {
          const { data } = res
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },

    //评价类型状态切换
    tableStatusChange(val) {
      this.$message.destroy()
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.statusAbilitylevelReferencetype(val.id)
        .then((res) => {
          const { message } = res
          this.$message.success(message)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //编辑评价类型
    edit(val) {
      this.modelForm.title = '编辑评价类型'
      for (let key in this.modelForm.data) {
        this.modelForm.data[key] = val[key]
      }
      this.modelForm.visible = true
    },
    //删除评价类型
    del(val) {
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.deleteAbilitylevelReferencetype(val.id)
        .then((res) => {
          const { message } = res
          this.$message.success(message)
          this.getPageList(1)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },

    //弹出框确认
    modelFormOk() {
      this.$refs.myModelForm.validate((valid) => {
        if (valid) {
          const bool = this.modelForm.title === '添加评价类型'
          const Ajax = bool ? this.$http.ReportService.addAbilitylevelReferencetype : this.$http.ReportService.updateAbilitylevelReferencetype
          let params = {}
          for (let key in this.modelForm.data) {
            params[key] = this.modelForm.data[key]
          }
          params['AbilityEvaluationSysId'] = this.abilitySystemTypeId
          if (bool) {
            delete params.id
          }
          this.modelForm.confirmLoading = true
          Ajax({ ...params })
            .then((res) => {
              this.modelForm.confirmLoading = false
              const { message } = res
              this.$message.success(message)
              this.modelFormCancel()
              this.getPageList(1)
            })
            .finally(() => {
              this.modelForm.confirmLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //弹出框取消
    modelFormCancel() {
      this.modelForm.visible = false
      this.modelForm.title = '添加评价类型'
      this.modelForm.data = {
        id: undefined,
        referenceType: '',
        enabled: true,
      }
    },
  },
}
</script>

<style scoped>
.header {
  margin-bottom: 15px;
}
</style>
